<template>
  <div style="margin-botton: 30px">
    <van-nav-bar title="我的订单" left-arrow @click-left="onClickLeft" right-text="搜索" @click-right="showPopupRight"/>
    <van-calendar v-model="dateShow" @confirm="onConfirm"  :min-date="minDate" :max-date="maxDate"/>
    <van-calendar v-model="dateShowEnd" @confirm="onConfirmend"  :min-date="minDate" :max-date="maxDate"/>
    <van-dialog v-model="show" title="订单搜索" @cancel="searchCancel" @confirm="searchDetermine" show-cancel-button>
      <van-field style="" v-model="searchForm.searchrqStart" @click="dateChoice" readonly label="开始日期" placeholder="请输入日期" />
      <van-field style="" v-model="searchForm.searchrqEnd" @click="dateChoiceEnd" readonly label="截止日期" placeholder="请输入日期" />
<!--      <van-field v-model="searchForm.searchkhmc" label="开票名称" placeholder="请输入开票名称" />-->
      <van-field v-model="searchForm.searchje" label="金额" type="number" placeholder="请输入金额" />
<!--      <van-field v-model="searchForm.searchspmc" label="商品名称" placeholder="请输入商品名称" />-->
      <van-field v-model="searchForm.customerName" maxlength="100" label="商铺名称" placeholder="商铺名称"/>
<!--      <van-field v-model="searchForm.dzCountyText" label="区/县" readonly @click="qxClick" placeholder="区/县"/>-->
<!--      <van-field v-model="searchForm.dzShreetText" label="街道/乡" readonly @click="jxClick" placeholder="街道/乡"/>-->
      <van-field v-model="searchForm.address" label="地址" placeholder="地址"/>
      <van-field v-model="searchForm.waterMeterNo" label="水表号" placeholder="水表号"/>
    </van-dialog>
<!--    <van-popup v-model="qxShow" position="bottom" >-->
<!--      <van-picker-->
<!--          title="区/县"-->
<!--          show-toolbar-->
<!--          :columns="qxColumns"-->
<!--          @confirm="qxConfirm"-->
<!--          @cancel="qxShow = false"-->
<!--      />-->
<!--    </van-popup>-->
<!--    <van-popup v-model="jxShow" position="bottom" >-->
<!--      <van-picker-->
<!--          title="街道/乡"-->
<!--          show-toolbar-->
<!--          :columns="jxColumns"-->
<!--          @confirm="jxConfirm"-->
<!--          @cancel="jxShow = false"-->
<!--      />-->
<!--    </van-popup>-->
      <van-tabs v-model="activeNav" @click="clickNav">
      <van-tab v-for="nav in navList" :title="nav.name" v-bind:key="nav.id">
      </van-tab>
    </van-tabs>
    <div class="order_list">
      <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad">
        <van-panel
            v-for="(item, index) in orderList"
            :key="index"
            :title="
            '订单号:' +
            item.orderSn"
            :status="stateIdentification(item.orderStatus)">
              <van-cell >
                <template #title>
                  <span >商户名称：{{item.customerName}}</span>
                </template>
              </van-cell>
          <van-card
              v-for="(orderItem, index2) in item.items"
              :key="index2"
              :title="orderItem.spName"
              :desc="orderItem.spContext"
              :num="orderItem.count"
          >
            <template #price>
              <span>单价：￥{{jezh(orderItem.je)}}</span>
            </template>
            <template #num>
              <span>数量：x{{orderItem.count}}</span>
            </template>
          </van-card>
          <div class="total">合计: ￥{{ toDecimal(item.orderZje) +'/年'}}</div>
          <div slot="footer" class="footer_btn">
             <div style="float: left;font-size: 12px;
    padding-top: 9px;">
              {{item.addtime}}
            </div>
            <van-button
                size="small"
                @click.stop="cancelOrder(item)"
                v-show="item.orderStatus === '0'"
                type="default"
            >{{
                item.orderStatus === "0" ? "取消订单" : "已取消"
              }}</van-button
            >
            <van-button
                size="small"
                @click="toOrderInfo(item.id)">
              查看详情
            </van-button>
            <van-button
                size="small"
                @click="toInvoiceInfo(item.invoiceId)"
                v-show="item.orderStatus == '4'">
              查看发票
            </van-button>
            <van-button
                size="small"
                :loading="item.logg"
                loading-text="加载中..."
                @click.stop="handleOrder(item)"
                v-show="item.orderStatus === '0'||item.orderStatus === '1'||item.orderStatus === '5'"
                type="danger">
              {{ getHandlerText(item) }}
            </van-button>
          </div>
        </van-panel>
      </van-list>
    </div>
  </div>
</template>

<script>
import {Indicator} from "mint-ui";
import {
  Button,
  Calendar,
  Card,
  Checkbox,
  CheckboxGroup,
  Col,
  Dialog,
  Divider,
  Field,
  List,
  NavBar,
  Panel,
  Popup,
  Row,
  SubmitBar,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast
} from "vant";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabbar.name]: Tabbar,
    [Tabs.name]: Tabs,
    [TabbarItem.name]: TabbarItem,
    [Panel.name]: Panel,
    [List.name]: List,
    [Button.name]: Button,
    [Field.name]:Field,
    [Dialog.Component.name]: Dialog.Component,
    [Divider.name]: Divider,
    [Popup.name]:Popup,
    [Calendar.name]:Calendar
  },
  data() {
    return {
      qxShow:false,
      jxShow:false,
      navList: [
        { name: "全部", id: "-1" },
        { name: "待付款", id: "0" },
        { name: "已付款", id: "1" },
        { name: "已开票", id: "4" },
      ],
      orderList: [],
      activeNav: 1,
      pages:1,
      show: false,
      activeFooter: 3,
      date:'',
      checkedGoods: ["1"],
      goods: [],
      // qxColumns:[],
      // jxColumns:[],
      dateShow: false,
      dateShowEnd:false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2050, 0, 31),
      searchState:'',
      searchForm:{
        searchrqStart:'',
        searchrqEnd:'',
        searchkhmc:'',
        searchje:'',
        searchspmc:'',
        corpName:'',
        address:'',
        waterMeterNo:''
      },
      displaySta:'', //订单状态
      tempId:-1,  //临时变量用于操作退款
      refundDialog:false,
      refundInstructions:'',
      listQuery: {
        page: 1,
        limit: 20,
        status: 0,
      },
      loading: false,
      finished: false,
    };
  },
  mounted() {
    this.init();  //初始化
  },
  methods: {

    showPopupRight(){
      this.show = true
    },
    refundOrder(id){
        this.refundDialog=true;
        this.tempId=id;
    },
    qxClick(){
      this.qxShow = true
    },
    jxClick(){
      this.jxShow = true
    },
    onLoad() {
      var that = this
        var para = {};
        if (this.searchState != -1 && this.searchState != null) {
          switch (
              this.searchState // 0 未付款    1 已付款   3已开票
              ) {
            case "0":
              para = "0";
              break;
            case "1":
              para = "1,3,4,5,6";
              break;
            case "3":
              para = "4";   //订单成功
              break;
            case "4":
                para = "4";
          }
        } else {
          para = "0,1,2,3,4,5,6,7,8";
        }
        if(this.searchForm.searchje.indexOf(".")===-1){
          this.searchForm.searchje = this.searchForm.searchje+'.00'
        }

        let money=this.searchForm.searchje;

        if(this.searchForm.searchje==='0.00'||this.searchForm.searchje==='.00'){
          money='';
        }
        console.log('参数：'+money);
        var OrderSearchFrontVo ={
          dateStart: this.searchForm.searchrqStart,
          dateEnd: this.searchForm.searchrqEnd,
          customerName: this.searchForm.customerName,
          money: money,
          spmc: this.searchForm.searchspmc,
          orderStatus: para,
          corpName: this.searchForm.corpName,
          address:this.searchForm.address,
          waterMeterNo: this.searchForm.waterMeterNo
        }
      console.log(OrderSearchFrontVo)
        this.$axios
            .get("/memberBusiness/order/"+(that.pages++)+"/"+30+"/findOrders", OrderSearchFrontVo)
            .then((data) => {
              if (data.code === 200) {

                if(data.data.length<1){
                  this.finished = true;
                }
                var orqw = data.data;
                var qwe = [];
                orqw.forEach(function (item) {
                  that.orderList.push({
                    orderPay:item.orders.orderPay,
                    orderZje: item.orders.orderZje,
                    orderStatus: item.orders.orderStatus,
                    orderSn: item.orders.orderCode,
                    items: item.orderQueries,
                    id: item.orders.id,
                    addtime: item.orders.addDate,
                    customerPhone:item.orders.customerPhone,
                    customerName:item.orders.customerName,
                    logg: false,
                    invoiceId: item.orders.invoiceId,
                    enterpriseId: item.orders.enterpriseId,
                    isContract: item.isContract,

                  });
                });

                Indicator.close();

              } else {
                Indicator.close();
                Toast(data.message);
              }
            });
        Indicator.close();

        // 加载状态结束
        this.loading = false;
    },
    init() {
     
      var status = this.$route.query.status; //取订单状态
      if (status === undefined) {
        status = "-1";
      }
      if (status == "-1") {   //默认是全部  
        this.activeNav = 0;
      } else if (status == "0") {
        status = "0"
        this.activeNav = 1;
      } else if (status == "1") {
        status = "1"
        this.activeNav = 2;
      } else if (status == "3") {
        status = "3"
        this.activeNav = 3;
      } else if (status == "4") {
        status = "4"
        this.activeNav = 4;
      }
       this.getData(status);     //取数据
    },
    searchCancel(){
      this.show = false
    },
    onConfirm(date) {
      this.dateShow = false;
      this.date = this.formatDate(date,'YYYY-MM-dd');
      this.searchForm.searchrqStart = "20"+this.date
    },
    jezh(val){
        return val+".00"
    },
    onConfirmend(date) {
      this.dateShowEnd = false;
      this.date = this.formatDate(date,'YYYY-MM-dd');
      this.searchForm.searchrqEnd = "20"+this.date
    },
    dateChoice(){
      this.dateShow = true
      this.searchForm.searchrqStart = ''
    },
    dateChoiceEnd(){
      this.dateShowEnd = true
      this.searchForm.searchrqEnd = ''
    },
    formatDate(date, fmt) {
      let o = {
        'Y+': date.getYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
        }
      }
      return fmt
    },
    padLeftZero (str) {
      return ('00' + str).substr(str.length)
    },
    searchDetermine(){
      this.getData(this.searchState)  //取数据
      this.show = false
    },
    getData(status) {
      this.finished = false;
      this.pages=1;
      //取数据
      this.searchState = status
      this.displaySta = status
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle"
      });
      setTimeout(() => {
        Indicator.close();
      }, 60000);
      var para = {};
      if (status != -1 && status != null) {
        switch (
            status // 0 未付款    1 已付款   3已开票
            ) {
          case "0":
            para = "0";
            break;
          case "1":
            para = "1,3,4,5,6";
            break;
          case "3":
            para = "3";
            break;
          case "4":
            para = "4";
        }
      } else {
        para = "0,1,2,3,4,5,6,7,8";
      }
      if(this.searchForm.searchje.indexOf(".")===-1){
          this.searchForm.searchje = this.searchForm.searchje+'.00'
        }

        let money=this.searchForm.searchje;

        if(this.searchForm.searchje==='0.00'||this.searchForm.searchje==='.00'){
          money='';
        }
      var OrderSearchFrontVo ={
        dateStart: this.searchForm.searchrqStart,
        dateEnd: this.searchForm.searchrqEnd,
        customerName: this.searchForm.customerName,
        money: money,
        spmc: this.searchForm.searchspmc,
        orderStatus: para,
        corpName: this.searchForm.corpName,
        address:this.searchForm.address,
        waterMeterNo: this.searchForm.waterMeterNo
      }
      this.$axios
          .get("/memberBusiness/order/"+(this.pages++)+"/30/findOrders", OrderSearchFrontVo)
          .then((data) => {
            if (data.code === 200) {
              var orqw = data.data;
              var qwe = [];
              // console.log("???")
              console.log('数据');
              console.log(data)
              orqw.forEach(function (item) {
                qwe.push({
                  orderPay:item.orders.orderPay,
                  orderZje: item.orders.orderZje,
                  orderStatus: item.orders.orderStatus,
                  orderSn: item.orders.orderCode,
                  items: item.orderQueries,
                  id: item.orders.id,
                  addtime: item.orders.addDate,
                  customerPhone:item.orders.customerPhone,
                  customerName:item.orders.customerName,
                  logg: false,
                  invoiceId: item.orders.invoiceId,
                  enterpriseId: item.orders.enterpriseId,
                  isContract: item.isContract,
                  corpName: item.orders.corpName
                });
              });
              this.orderList = qwe;
              Indicator.close();
            } else {
              Indicator.close();
              Toast(data.message);
            }
          });
      this.loading = false;
      Indicator.close();
    },
    onClickLeft() {  //控制回退
      let linkObj=sessionStorage.getItem("pageLink");
      var obj = JSON.parse(linkObj)
      if(obj.lastPage=='collection'){
        this.$router.push({ path: "/home" });
      }else{
          // this.$router.go(-1);
    
         this.$router.push({ path: "/user" });

      }

    },
    clickNav(index, title) {   //点击tabs

      this.activeNav = index;
      this.listQuery.status = this.navList[index].id;
      this.getData(this.navList[index].id);
    },
    cancelOrder(orderInfo) {  //取消订单
      Dialog.confirm({
        title: "提示",
        message: "是否取消订单",
        confirmButtonColor:"#1989fa" 
      })
        .then(() => {
            this.$axios
          .post("/memberBusiness/order/upOrders", {
            id: orderInfo.id,
            orderStatus: "2",
          })
          .then((data) => {
            if (data.code === 200) {
              Toast(data.message);
              this.getData(this.displaySta);
            } else {
              Toast(data.message);
            }
          });
           

        })
        .catch(() => {
        });
    },
    toOrderInfo(id){   //查看订单详情
      this.$router.push('/orderInfo?id='+id)
    },
    // qxConfirm(item){
    //   var that = this
    //   this.$axios
    //       .get('/memberBusiness/sysArea/sysareaList',{parentId:item.value})
    //       .then((data) => {
    //         that.jxColumns = [{text:'全部',value:''}]
    //         data.obj.forEach((a)=>{
    //           that.jxColumns.push({text:a.name,value:a.id})
    //         })
    //       })
    //       .catch(
    //           function (response) {
    //             this.$message.error('操作失败请重试');
    //           }.bind(this)
    //       );
    //   this.searchForm.dzShreetId = ''
    //   this.searchForm.dzShreetText = ''
    //   this.searchForm.dzCountyId = item.value
    //   this.searchForm.dzCountyText = item.text
    //   this.qxShow = false
    // },
    // jxConfirm(item){
    //   this.searchForm.dzShreetId = item.value
    //   this.searchForm.dzShreetText = item.text
    //   this.jxShow = false
    // },
    getHandlerText(val) {
      var statusName="0"
      if(val.orderStatus==="0"){
          return "立即付款"
      }else{
        statusName = val.orderStatus
      }
      if (statusName === "1") {
        return "立即开票";
      }
      if (statusName === "3") {
        return "查看申请";
      }
      if (statusName === "4") {
        return "查看发票";
      }
      if (statusName === "5") {
        return "重新开票";
      }
      return statusName;
    },

 stateIdentification(str){  //订单
      switch (
          str // 0 未付款    1 已付款   3已开票
          ) {
        case "0":
          return '待支付'
          break;
        case "1":
          return '已付款'
          break;
        case "2":
          return '已取消'
          break;
        case "3":
          return '开票申请中'
          break;
        case "4":
          return '开票成功'
          break;
        case "5":
          return '开票中...'
          break;
      }
    },
    toInvoiceInfo(item) {  //去查看发票
      this.$axios
          .get("/memberBusiness/invoice/" + item + "/invoiceinformationList")
          .then((data) => {
            if (data.code === 200) {
              this.$router.push({
                path: "/invoiceInfo",
                query: { datass: data.data },
              });
            } else {
              Toast("未申请发票");
            }
          });
    },
    handleOrder(orderInfo) {     //操作订单
      switch(orderInfo.orderStatus ){
        case "0":
          var jump ="/collection";
          let orderInfoVo = {
            enterpriseId: orderInfo.enterpriseId,
          };
          sessionStorage.setItem("orderZje",orderInfo.orderZje);
          this.$router.push({
            path: jump,
            query: {
              orderZje: orderInfo.orderZje,
              orderId: orderInfo.orderSn
            },
          });
      break;
    case "1":
          Toast("开票中,请稍候");  
         break;
     case "5":  //重新去开票 
      
     Indicator.open({
        text: "开票申请中...",
        spinnerType: "fading-circle"
      });

       this.$axios
        .post("/memberBusiness/invoice/"+orderInfo.id+"/reInvoice").then((data) => {
          if (data.code === 200) {
                 Toast("申请成功,请稍候查看"); 
                 Indicator.close(); 
            } else {
                Toast("申请失败,请联系管理员");
                Indicator.close();
            }
      }).catch(() => {

        Indicator.close();
            
        });




      break;
      case  "3":  //重新去付款
        this.$router.push({name :"/payment", query: {orderid: orderInfo.id,enterpriseId: orderInfo.enterpriseId}});
        break;

      }


    },
  },
};
</script>

<style lang="less">

.order_list {
  .van-panel {
    margin-top: 5px;
  }

  .van-card {
    background-color: #fff;
  }

  .total {
    text-align: right;
    padding: 10px;
  }

  .footer_btn {
    text-align: right;
    .van-button {
      margin-left: 10px;
    }
  }
}
.buttonColor{
  color: #FF0000
}
</style>